import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/chat/[avatarId]/ClientChatPage.tsx");
